import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CountyDTO } from "../models/CountyDTO";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { CityDTO } from "../models/CityDTO";

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private http: HttpClient) {
  }

  getCounties(): Observable<CountyDTO[]> {
    return this.http.get<CountyDTO[]>(environment.loggedInUrl + `/lista-judete`);
  }

  getCounty(countyId: number): Observable<CountyDTO> {
    return this.http.get<CountyDTO>(environment.loggedInUrl + `/judet/${countyId}`);
  }

  getCity(cityId: number): Observable<CityDTO> {
    return this.http.get<CountyDTO>(environment.loggedInUrl + `/oras/${cityId}`);
  }

  getCities(countyId: number): Observable<CityDTO[]> {
    return this.http.get<CityDTO[]>(environment.loggedInUrl + `/lista-orase/${countyId}`);
  }
}
